// extracted by mini-css-extract-plugin
export default {"menuPaper":"ContextMenu_menuPaper__Cn133"};